import { render, staticRenderFns } from "./tr_ver.vue?vue&type=template&id=3e8255d3&scoped=true&"
import script from "./tr_ver.vue?vue&type=script&lang=js&"
export * from "./tr_ver.vue?vue&type=script&lang=js&"
import style0 from "./tr_ver.vue?vue&type=style&index=0&id=3e8255d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8255d3",
  null
  
)

export default component.exports